export default __webpack_public_path__ + "static/vg-3810409aa169307021479ae15effa5f7.svg";